import { c as _c } from "react/compiler-runtime";
import { postHostedUserChallenge, postHostedUserChallengeVerify } from '@onefootprint/fetch-hosted';
import type { ActionKind } from '@onefootprint/request-types';
import { useMutation } from '@tanstack/react-query';
import type { RegisterPasskeyError } from './types';
import { isRegisterPasskeyError, unwrapPasskeyError } from './utils/passkey-error';
import { registerPasskeyOnDevice } from './utils/register-passkey';
export { isRegisterPasskeyError, unwrapPasskeyError };
const useBiometricInit = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useBiometricInit;
async function _temp(t0) {
  const {
    token,
    actionKind
  } = t0;
  const {
    data: challengeData
  } = await postHostedUserChallenge({
    headers: {
      "X-Fp-Authorization": token
    },
    body: {
      kind: "passkey",
      actionKind
    },
    throwOnError: true
  });
  if (!challengeData.biometricChallengeJson) {
    throw new Error("No biometric challenge JSON when registering passkey");
  }
  const startPasskeyRegister = Date.now();
  let challengeResponse;
  ;
  try {
    challengeResponse = await registerPasskeyOnDevice(challengeData.biometricChallengeJson);
  } catch (t1) {
    const error = t1;
    const elapsedTimeInOsPromptMs = Date.now() - startPasskeyRegister;
    const e = {
      kind: "registerPasskeyError",
      elapsedTimeInOsPromptMs,
      error
    };
    return Promise.reject(e);
  }
  const {
    data: verifyData
  } = await postHostedUserChallengeVerify({
    headers: {
      "X-Fp-Authorization": token
    },
    body: {
      challengeToken: challengeData.challengeToken,
      challengeResponse
    },
    throwOnError: true
  });
  return {
    response: verifyData,
    deviceResponseJson: challengeResponse
  };
}